import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    width: calc(${`${displayState.progress}%`} - 6px);
    height: 90%;
    top: 5%;
    border-radius: 90px;
    background-color: ${displayState?.color};
    position: absolute;
    left: 3px;
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })